<template>
    <div>
        <figure class="newTourFigure">
            <div class="gradient-box"></div>
            <label for="files">
                <input class="file-input" accept="image/*" type="file" id="files" ref="files" v-on:change="handleFiles()"/>
                <div class="upload-icon visible-upload-icon">
                    <span class="md-button md-theme-default">
                        <md-icon class="photo-icon">photo_size_select_actual</md-icon>
                        <p class="upload-text" v-if="!fileflag">Click to upload a tour image</p>
                        <p class="upload-text" v-else><img id="blah" :src="preViewImage" alt="your image" style="position: absolute;    top: 8px;
                        /* margin-left: -16px; */
                        left: 3px;
                        right: -2px;
                        margin-right: -4px;"></p>
                    </span>
                </div>
            </label>
            <md-button class="close-new-tour md-icon-button" @click="returnToPrevious" aria-label="Back">
                <md-icon>close</md-icon>
            </md-button>
            <img class="newTourlogo" :src="getImageSrc('logo.png')">
        </figure>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  data: () => ({
    fileflag: false,
    files: '',
    preViewImage: ''
  }),
  computed: {
    ...mapGetters('tours', ['currentTourImage'])
  },
  methods: {
    ...mapActions('tours', ['loadTourEditorImage']),
    handleFiles () {
      let uploadedFiles = this.$refs.files.files;
      this.files = uploadedFiles[0];
      this.preViewImage = URL.createObjectURL(uploadedFiles[0]);
      this.fileflag = true;
      this.loadTourEditorImage(this.files);
    },
    returnToPrevious () {
      this.$router.push('/client/tours');
    },
    getImageSrc (image) {
      return 'static/img/' + image;
    }
  }
};
</script>
<style lang="scss">
.newTourFigure .newTourlogo {
    margin-top: 30px !important;
    min-height: 110px !important;
    margin-bottom: 0px;
}

.upload-btn .file-input {
    position: absolute !important;
    height: 100% !important;
    width: 100% !important;
    opacity: 0 !important;
}

.map-page .upload-btn.btn-for-upload {
    position: relative !important;
    top: auto !important;
    right: auto !important;
}

.upload-text {
    position: static !important;
    top: auto !important;
}

.upload-icon.visible-upload-icon .md-button-content {
    display: block;
    width: 100%;
}

.photo-icon {
    display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/NewTourFigure.vue